import React from 'react';
import { RefreshCw } from 'lucide-react';

interface UpdatePromptProps {
  onUpdate: () => void;
}

export function UpdatePrompt({ onUpdate }: UpdatePromptProps) {
  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="glass-panel p-4 rounded-lg shadow-lg flex items-center space-x-4">
        <p className="text-sm text-slate-300">A new version is available!</p>
        <button
          onClick={onUpdate}
          className="btn-primary text-sm flex items-center space-x-2 py-2"
        >
          <RefreshCw className="w-4 h-4" />
          <span>Update</span>
        </button>
      </div>
    </div>
  );
}